import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 34,
  medium: 23,
  small: 18,
  xSmall: 15
};
const CartTwoDigitBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    )
  );
};
CartTwoDigitBoldIcon.iconName = "CartTwoDigitBoldIcon";

export { CartTwoDigitBoldIcon };
